import * as React from 'react';
import { Header1 } from '@cian/ui-kit';
import * as styles from './styles.css';

interface IRealtyValuationHeaderProps {
  aside: React.ReactNode;
}

export function Header({ aside }: IRealtyValuationHeaderProps) {
  return (
    <div className={styles['container']}>
      <Header1 as="h2">Динамика изменения цены на квартиры в ЖК</Header1>
      <div className={styles['aside']}>{aside}</div>
    </div>
  );
}
